export default __webpack_public_path__ + "static/media/8.71f3b94a.jpg";